/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Mirrors LayoutChangeEnforcer.matchingCategories in core:
 * which Ruleset.LayoutCategory values a layout currently satisfies.
 */

const LAYOUT_CATEGORY_ORDER = [
  'FULL_PAGE',
  'POLITICAL',
  'HTML',
  'VAST',
  'NATIVE',
  'THIRD_PARTY',
  'STANDARD',
  'DATA',
  'IMAGE'
];

export function layoutCategoriesFor(layout: any): string[] {
  if (!layout) {
    return [];
  }

  const matched = new Set<string>();
  if (layout.fullPage) {
    matched.add('FULL_PAGE');
  }
  if (layout.political) {
    matched.add('POLITICAL');
  }
  if (layout.detectedCategory === 'IMAGE') {
    matched.add('IMAGE');
  }
  switch (layout.layoutType) {
    case 'HTML':
      matched.add('HTML');
      break;
    case 'VAST':
      matched.add('VAST');
      break;
    case 'NATIVE':
      matched.add('NATIVE');
      break;
    case 'THIRD_PARTY':
      matched.add('THIRD_PARTY');
      break;
    case 'STANDARD':
      matched.add('STANDARD');
      break;
    case 'DATA':
      matched.add('DATA');
      break;
    default:
      break;
  }

  return LAYOUT_CATEGORY_ORDER.filter((category) => matched.has(category));
}
